import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HrIcon = ({ color })=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsxs("g", {
                clipPath: "url(#clip0_1518_54262)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        d: "M3.86963 6.35416C3.86963 7.13427 4.17953 7.88242 4.73115 8.43405C5.28278 8.98569 6.03095 9.29559 6.81106 9.29559C7.59118 9.29559 8.33935 8.98569 8.89096 8.43405C9.4426 7.88242 9.7525 7.13427 9.7525 6.35416C9.7525 5.57404 9.4426 4.82587 8.89096 4.27424C8.33935 3.72262 7.59118 3.41272 6.81106 3.41272C6.03095 3.41272 5.28278 3.72262 4.73115 4.27424C4.17953 4.82587 3.86963 5.57404 3.86963 6.35416Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M1.99756 15.1715C1.99756 13.895 2.50467 12.6707 3.40733 11.768C4.30999 10.8654 5.53426 10.3583 6.81082 10.3583C8.08737 10.3583 9.31165 10.8654 10.2143 11.768C11.1169 12.6707 11.6241 13.895 11.6241 15.1715",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M11.6973 7.95424C11.6973 8.59251 11.9508 9.20462 12.4021 9.65599C12.8534 10.1073 13.4655 10.3609 14.1038 10.3609C14.7422 10.3609 15.3543 10.1073 15.8056 9.65599C16.257 9.20462 16.5105 8.59251 16.5105 7.95424C16.5105 7.31596 16.257 6.70382 15.8056 6.25249C15.3543 5.80116 14.7422 5.54761 14.1038 5.54761C13.4655 5.54761 12.8534 5.80116 12.4021 6.25249C11.9508 6.70382 11.6973 7.31596 11.6973 7.95424Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        d: "M12.739 11.4793C13.3345 11.2598 13.9741 11.1874 14.6036 11.2683C15.2331 11.3491 15.8337 11.5807 16.3544 11.9435C16.8751 12.3064 17.3005 12.7896 17.5943 13.3521C17.8881 13.9146 18.0418 14.5398 18.0422 15.1744",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1518_54262",
                    children: /*#__PURE__*/ _jsx("rect", {
                        width: "17.1138",
                        height: "17.1138",
                        fill: "white",
                        transform: "translate(1.46265 0.731323)"
                    })
                })
            })
        ]
    });
